export enum ObjectAliases {
  CABINETS = 'cabinets',
  GROUPS = 'groups',
  INVENTORY = 'inventory',
  UNDEFINED = 'undefined',
}

export enum ObjectTypeIds {
  CABINETS = 1,
  GROUPS = 3,
  UNDEFINED = 0,
}

export const ObjectTypes = {
  1: { name: 'ШУНО', icon: 'host', id: 1, alias: ObjectAliases.CABINETS },
  2: { name: 'Светильник', icon: 'lightbulb_2', id: 2, alias: ObjectAliases.UNDEFINED },
  3: { name: 'Групповой объект', icon: 'stack', id: 3, alias: ObjectAliases.GROUPS },
  4: { name: 'Счетчик', icon: 'readiness_score', id: 4, alias: ObjectAliases.UNDEFINED },
  6: { name: 'Дорожный датчик', icon: 'road', id: 6, alias: ObjectAliases.UNDEFINED },
  7: { name: 'Метеостанция', icon: 'thermostat', id: 7, alias: ObjectAliases.UNDEFINED },
  8: { name: 'Камера', icon: 'camera_video', id: 8, alias: ObjectAliases.UNDEFINED },
  9: { name: 'ДСПД', icon: 'detector', id: 9, alias: ObjectAliases.UNDEFINED },
  10: { name: 'Трекер', icon: 'directions_car', id: 10, alias: ObjectAliases.UNDEFINED },
  11: { name: 'Монитор трафика', icon: 'road', id: 11, alias: ObjectAliases.UNDEFINED },
  12: { name: 'Опора', icon: 'target', id: 12, alias: ObjectAliases.UNDEFINED },
  13: { name: 'Линия электропередач', icon: 'route', id: 13, alias: ObjectAliases.UNDEFINED },
  14: { name: 'ТД-11', icon: 'thermometer', id: 14, alias: ObjectAliases.UNDEFINED },
  15: { name: 'MS0101', icon: 'emoji_people', id: 15, alias: ObjectAliases.UNDEFINED },
  16: { name: 'КТР-121', icon: 'emergency_heat', id: 16, alias: ObjectAliases.UNDEFINED },
  17: { name: 'Мусорный контейнер', icon: 'delete', id: 17, alias: ObjectAliases.UNDEFINED },
  18: {
    name: 'Пешеходный переход',
    icon: 'directions_run',
    id: 18,
    alias: ObjectAliases.UNDEFINED,
  },
  19: { name: 'Монитор номеров', icon: 'directions_car', id: 19, alias: ObjectAliases.UNDEFINED },
  20: { name: 'Счётчик импульсов', icon: 'leak_add', id: 20, alias: ObjectAliases.UNDEFINED },
  21: { name: 'Зарядная станция', icon: 'ev_station', id: 21, alias: ObjectAliases.UNDEFINED },
  22: { name: 'Умная опора', icon: 'nest_cam_indoor', id: 22, alias: ObjectAliases.UNDEFINED },
  23: { name: 'Трекер людей', icon: 'group_add', id: 23, alias: ObjectAliases.UNDEFINED },
  24: {
    name: 'Произвольный объект карты',
    icon: 'not_listed_location',
    id: 24,
    alias: ObjectAliases.UNDEFINED,
  },
  25: { name: 'Модем', icon: 'network_node', id: 25, alias: ObjectAliases.UNDEFINED },
}

export const ObjectTypesMap = {
  [ObjectAliases.CABINETS]: ObjectTypes['1'],
  [ObjectAliases.GROUPS]: ObjectTypes['3'],
}

export type ObjectListItemMap = {
  id: number
  object_type_id: number
  is_connected: boolean
  is_error: boolean
  longitude: number
  latitude: number
}

export type ObjectsListItemMap = {
  id: number
  name: string
  object_type_id: number
  is_connected: boolean
  status: number
  power_status: number
  control_mode: number
  latitude: number
  longitude: number
  coords: number[][]
}

export type ObjectPinStatuses = {
  pin_number: number
  event_time: string
  device_event_type_id: number
  value: number
}

export enum EventErrorType {
  WARNING = 0,
  ERROR = 1,
  SUCCESS = 2,
}

/**
 * Функция получения url по типу объекта
 * @param object
 * @param page
 */
export const generateUrlToType = (object: { id: number; type: number }, page = 'monitoring') => {
  return `/objects/${ObjectTypes[object.type].alias}/${object.id}/${page}`
}

/**
 * Функция фильтрации типов объектов
 * @param ids
 */
export const getFilteredObjects = (ids: number[]) => {
  const items: any[] = []
  const keys = Object.keys(ObjectTypes)

  for (let key in keys) {
    if (ids.includes(Number(key))) {
      items.push(ObjectTypes[key])
    }
  }

  return items
}
